var _style, _linearGradient, _path, _path2, _path3, _path4, _circle, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 500 500",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st1,.st3{fill:none;stroke:#5a4f51;stroke-width:35;stroke-linecap:round;stroke-linejoin:round}.st3{stroke:#e472ac;stroke-width:23}")), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 221.236,
    y1: 457.209,
    x2: 221.236,
    y2: 119.114,
    gradientTransform: "matrix(1 0 0 -1 0 535.6)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f393bd"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M396.7 416.5h-351c-19.9 0-36-14.4-36-32.1V110.6c0-17.8 16.1-32.2 36-32.2h351.1c19.9 0 36 14.4 36 32.1v273.7c0 17.8-16 32.2-35.9 32.2h-.2z",
    fill: "url(#SVGID_1_)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M104.1 67v39M339.8 67.3v39.1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M397.7 76.9H43.9C24 76.8 7.7 91.2 7.6 109.1v41.8H434v-41.8c0-17.7-16.3-32.2-36.3-32.2z",
    fill: "#5a4f51"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M240.9 208.7h-43.7M117.8 209H74.1M117.2 258.5H73.5M118.1 310.7H74.4M117.5 360.2H73.8M240.3 258.2h-43.7M241.2 310.4h-43.7M240.6 359.9h-43.7M362 209.3h-43.7M361.4 258.8h-43.7M362.4 311h-43.7"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 401,
    cy: 376.6,
    r: 92,
    fill: "#fff",
    stroke: "#e472ac",
    strokeWidth: 11,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#5a4f51",
    strokeWidth: 11,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M401 330.1v46.5l37.4 37.4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.59eace384b361b909ddc4628c5a04615.svg";
export { ForwardRef as ReactComponent };